import React from 'react';
import { useLanguage } from '../../i18n';
import ImageGallery from './ImageGallery';
import Linkify from './Linkify';
import PostVideo from './PostVideo';

/**
 * Long-article sections (blocks). One article can hold several, each with its
 * own images + video link + text (added with “+ Add more” in the composer).
 *
 * Feed card: **nothing but a small “+N Section · Read more” hint** — the article
 * content itself (and every section) is shown **only on the post detail page**,
 * where all sections are rendered in full inside the main article card.
 */
export default function PostBlocks({ blocks, alt = '', hint = false }) {
  const { t } = useLanguage();

  const rows = Array.isArray(blocks)
    ? blocks.filter((b) => b && (b.description || b.video_url || (b.images || []).length))
    : [];
  if (rows.length === 0) return null;

  // Feed card: only the hint that the article has more inside.
  if (hint) {
    return (
      <p className="mt-2 text-[11px] font-semibold text-gray-400">
        +{rows.length} {t('section')} · {t('readMore')}
      </p>
    );
  }

  // Article / detail: every section, in full, plainly inside the main card.
  return (
    <div className="mt-3">
      {rows.map((b, i) => (
        <div
          key={`block-${i}`}
          className={i > 0 ? 'mt-3 pt-3 border-t border-gray-100 dark:border-gray-800' : ''}
        >
          {b.images?.length > 0 && (
            <div className="mt-2" onClick={(e) => e.stopPropagation()}>
              <ImageGallery images={b.images} alt={alt} />
            </div>
          )}
          {b.video_url && (
            <div onClick={(e) => e.stopPropagation()}>
              <PostVideo url={b.video_url} title={alt} />
            </div>
          )}
          {b.description && (
            <Linkify
              text={b.description}
              className="mt-2 text-sm text-gray-800 dark:text-gray-100"
            />
          )}
        </div>
      ))}
    </div>
  );
}
